// extracted by mini-css-extract-plugin
export default {"root":"styles__root__iCJrq","grid":"styles__grid__MQGpn"};